/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Message } from '../models/message';
import { LinhaExtratoContaCreditoPaginado } from '../models/linha-extrato-conta-credito-paginado';
import { LinhaExtratoContaCredito } from '../models/linha-extrato-conta-credito';

/**
 * API responsavel pelos dados do extrato da conta crédito
 */
@Injectable({
  providedIn: 'root',
})
class ExtratoContaCreditoService extends __BaseService {
  static readonly importarExtratoPath = '/extrato-conta-credito';
  static readonly obterLinhasExtratoPath = '/extrato-conta-credito';
  static readonly obterLinhasExtratoParaValidacaoPath = '/extrato-conta-credito/linhas-extrato';
  static readonly excluirLinhaCreditoPath = '/extrato-conta-credito/excluir-linhas';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * importa um extrato de conta crédito
   * @param params The `ExtratoContaCreditoService.ImportarExtratoParams` containing the following parameters:
   *
   * - `nomeArquivo`: nome do aquivo
   *
   * - `file`: The file to upload."
   *
   * - `codigoContaCredito`: codigo conta credito
   *
   * @return Operacao realizada com sucesso
   */
  importarExtratoResponse(params: ExtratoContaCreditoService.ImportarExtratoParams): __Observable<__StrictHttpResponse<Message>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.nomeArquivo != null) { __formData.append('nomeArquivo', params.nomeArquivo as string | Blob);}
    if (params.file != null) { __formData.append('file', params.file as string | Blob);}
    if (params.codigoContaCredito != null) { __formData.append('codigoContaCredito', JSON.stringify(params.codigoContaCredito));}
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/extrato-conta-credito`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Message>;
      })
    );
  }
  /**
   * importa um extrato de conta crédito
   * @param params The `ExtratoContaCreditoService.ImportarExtratoParams` containing the following parameters:
   *
   * - `nomeArquivo`: nome do aquivo
   *
   * - `file`: The file to upload."
   *
   * - `codigoContaCredito`: codigo conta credito
   *
   * @return Operacao realizada com sucesso
   */
  importarExtrato(params: ExtratoContaCreditoService.ImportarExtratoParams): __Observable<Message> {
    return this.importarExtratoResponse(params).pipe(
      __map(_r => _r.body as Message)
    );
  }

  /**
   * Recupera uma listagem de linhas de extrato com base nos parametros informados
   * @param params The `ExtratoContaCreditoService.ObterLinhasExtratoParams` containing the following parameters:
   *
   * - `valorInicial`: Faixa de valor inicial na pesquisa
   *
   * - `valorFinal`: Faixa de valor final na pesquisa
   *
   * - `periodoInicial`: Data inicial da pesquisa
   *
   * - `periodoFinal`: Data final da pesquisa
   *
   * - `perPage`: Quantidade registros por pagina
   *
   * - `page`: Pagina inicial
   *
   * - `descricaoLancamento`: Descricao do lancamento
   *
   * - `codigoStatus`: Codigo do status da linha de extrato
   *
   * - `codigoContaCredito`: Codigo da conta de credito
   *
   * @return Operacao realizada com sucesso
   */
  obterLinhasExtratoResponse(params: ExtratoContaCreditoService.ObterLinhasExtratoParams): __Observable<__StrictHttpResponse<LinhaExtratoContaCreditoPaginado>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.valorInicial != null) __params = __params.set('valorInicial', params.valorInicial.toString());
    if (params.valorFinal != null) __params = __params.set('valorFinal', params.valorFinal.toString());
    if (params.periodoInicial != null) __params = __params.set('periodoInicial', params.periodoInicial.toString());
    if (params.periodoFinal != null) __params = __params.set('periodoFinal', params.periodoFinal.toString());
    if (params.perPage != null) __params = __params.set('perPage', params.perPage.toString());
    if (params.page != null) __params = __params.set('page', params.page.toString());
    if (params.descricaoLancamento != null) __params = __params.set('descricaoLancamento', params.descricaoLancamento.toString());
    if (params.codigoStatus != null) __params = __params.set('codigoStatus', params.codigoStatus.toString());
    if (params.codigoContaCredito != null) __params = __params.set('codigoContaCredito', params.codigoContaCredito.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/extrato-conta-credito`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<LinhaExtratoContaCreditoPaginado>;
      })
    );
  }
  /**
   * Recupera uma listagem de linhas de extrato com base nos parametros informados
   * @param params The `ExtratoContaCreditoService.ObterLinhasExtratoParams` containing the following parameters:
   *
   * - `valorInicial`: Faixa de valor inicial na pesquisa
   *
   * - `valorFinal`: Faixa de valor final na pesquisa
   *
   * - `periodoInicial`: Data inicial da pesquisa
   *
   * - `periodoFinal`: Data final da pesquisa
   *
   * - `perPage`: Quantidade registros por pagina
   *
   * - `page`: Pagina inicial
   *
   * - `descricaoLancamento`: Descricao do lancamento
   *
   * - `codigoStatus`: Codigo do status da linha de extrato
   *
   * - `codigoContaCredito`: Codigo da conta de credito
   *
   * @return Operacao realizada com sucesso
   */
  obterLinhasExtrato(params: ExtratoContaCreditoService.ObterLinhasExtratoParams): __Observable<LinhaExtratoContaCreditoPaginado> {
    return this.obterLinhasExtratoResponse(params).pipe(
      __map(_r => _r.body as LinhaExtratoContaCreditoPaginado)
    );
  }

  /**
   * Recupera uma listagem de linhas de extrato com base nos parametros informados
   * @param params The `ExtratoContaCreditoService.ObterLinhasExtratoParaValidacaoParams` containing the following parameters:
   *
   * - `valorComprovante`: Faixa de valor inicial na pesquisa
   *
   * - `dataComprovante`: Data do comprovante da pesquisa
   *
   * - `codigoContaCredito`: Codigo da conta de credito
   *
   * @return Operacao realizada com sucesso
   */
  obterLinhasExtratoParaValidacaoResponse(params: ExtratoContaCreditoService.ObterLinhasExtratoParaValidacaoParams): __Observable<__StrictHttpResponse<Array<LinhaExtratoContaCredito>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    (params.valorComprovante || []).forEach(val => {if (val != null) __params = __params.append('valorComprovante', val.toString())});
    (params.dataComprovante || []).forEach(val => {if (val != null) __params = __params.append('dataComprovante', val.toString())});
    (params.codigoContaCredito || []).forEach(val => {if (val != null) __params = __params.append('codigoContaCredito', val.toString())});
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/extrato-conta-credito/linhas-extrato`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<LinhaExtratoContaCredito>>;
      })
    );
  }
  /**
   * Recupera uma listagem de linhas de extrato com base nos parametros informados
   * @param params The `ExtratoContaCreditoService.ObterLinhasExtratoParaValidacaoParams` containing the following parameters:
   *
   * - `valorComprovante`: Faixa de valor inicial na pesquisa
   *
   * - `dataComprovante`: Data do comprovante da pesquisa
   *
   * - `codigoContaCredito`: Codigo da conta de credito
   *
   * @return Operacao realizada com sucesso
   */
  obterLinhasExtratoParaValidacao(params: ExtratoContaCreditoService.ObterLinhasExtratoParaValidacaoParams): __Observable<Array<LinhaExtratoContaCredito>> {
    return this.obterLinhasExtratoParaValidacaoResponse(params).pipe(
      __map(_r => _r.body as Array<LinhaExtratoContaCredito>)
    );
  }

  /**
   * Excluir linhas de crédito
   * @param linhasExtrato Objeto relatorio request
   * @return Operacao realizada com sucesso
   */
  excluirLinhaCreditoResponse(linhasExtrato?: Array<LinhaExtratoContaCredito>): __Observable<__StrictHttpResponse<Message>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = linhasExtrato;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/extrato-conta-credito/excluir-linhas`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Message>;
      })
    );
  }
  /**
   * Excluir linhas de crédito
   * @param linhasExtrato Objeto relatorio request
   * @return Operacao realizada com sucesso
   */
  excluirLinhaCredito(linhasExtrato?: Array<LinhaExtratoContaCredito>): __Observable<Message> {
    return this.excluirLinhaCreditoResponse(linhasExtrato).pipe(
      __map(_r => _r.body as Message)
    );
  }
}

module ExtratoContaCreditoService {

  /**
   * Parameters for importarExtrato
   */
  export interface ImportarExtratoParams {

    /**
     * nome do aquivo
     */
    nomeArquivo?: string;

    /**
     * The file to upload."
     */
    file?: Blob;

    /**
     * codigo conta credito
     */
    codigoContaCredito?: number;
  }

  /**
   * Parameters for obterLinhasExtrato
   */
  export interface ObterLinhasExtratoParams {

    /**
     * Faixa de valor inicial na pesquisa
     */
    valorInicial?: number;

    /**
     * Faixa de valor final na pesquisa
     */
    valorFinal?: number;

    /**
     * Data inicial da pesquisa
     */
    periodoInicial?: string;

    /**
     * Data final da pesquisa
     */
    periodoFinal?: string;

    /**
     * Quantidade registros por pagina
     */
    perPage?: number;

    /**
     * Pagina inicial
     */
    page?: number;

    /**
     * Descricao do lancamento
     */
    descricaoLancamento?: string;

    /**
     * Codigo do status da linha de extrato
     */
    codigoStatus?: number;

    /**
     * Codigo da conta de credito
     */
    codigoContaCredito?: number;
  }

  /**
   * Parameters for obterLinhasExtratoParaValidacao
   */
  export interface ObterLinhasExtratoParaValidacaoParams {

    /**
     * Faixa de valor inicial na pesquisa
     */
    valorComprovante?: Array<number>;

    /**
     * Data do comprovante da pesquisa
     */
    dataComprovante?: Array<string>;

    /**
     * Codigo da conta de credito
     */
    codigoContaCredito?: Array<number>;
  }
}

export { ExtratoContaCreditoService }
